// ** React Imports
import { useRef, useState } from 'react';

// ** Custom Components
import Wizard from '@components/wizard';

// ** Steps
import CreateActivityStep from './Activity/index';
import ActivityFormComponent from './Form';
import { CreateActivity, UpdateActivity } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const WizardHorizontal = ({
  defaultValues,
  editMode = false,
  activityId = '',
  handleChangeType,
  type,
  loading,
  setData,
  data
}) => {
  const [createActivity] = useMutation(CreateActivity);
  const [updateActivity] = useMutation(UpdateActivity);
  // ** Ref
  const ref = useRef(null);

  // ** State
  const [stepper, setStepper] = useState(null);
  const handleState = async (_data, done) => {
    const dataFormated = {
      ...data,
      ..._data,
      status: String(_data.status || data.status) === 'true',
      friends: _data.friends ? parseInt(_data.friends) : undefined
    };
    setData(() => dataFormated);
    try {
      if (done) {
        if (editMode) {
          await updateActivity({
            variables: {
              updateActivityInput: {
                _id: activityId,
                data: dataFormated
              }
            },
            refetchQueries: 'all'
          });
        } else {
          await createActivity({
            variables: {
              createActivityInput: dataFormated
            },
            refetchQueries: 'all'
          });
        }
        window.location.href = '/roads/activities/list';

        return MySwal.fire({
          title: editMode ? 'Actividad actualizada!' : 'Actividad creada!',
          text: editMode
            ? 'Actividad actualizada con exito!'
            : 'La actividad fue creada con exito!',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        });
      }
    } catch (e) {}
  };

  const steps =
    type === 'form'
      ? [
          {
            id: 'create-activity',
            title: 'Crea la Actividad',
            subtitle: 'Datos básicos del camino.',
            content: (
              <CreateActivityStep
                stepper={stepper}
                handleOnSubmit={handleState}
                type={type}
                editMode={editMode}
                defaultValues={defaultValues}
                handleChangeType={handleChangeType}
              />
            )
          },
          {
            id: 'form-activity',
            title: 'Crear Formulario',
            subtitle: 'Cargar Formulario',
            content: (
              <ActivityFormComponent
                stepper={stepper}
                handleOnSubmit={handleState}
                type={type}
                editMode={editMode}
                defaultValues={defaultValues}
              />
            )
          }
        ]
      : [
          {
            id: 'create-activity',
            title: 'Crea la Actividad',
            subtitle: 'Datos básicos del camino.',
            content: (
              <CreateActivityStep
                stepper={stepper}
                handleOnSubmit={handleState}
                type={type}
                editMode={editMode}
                defaultValues={defaultValues}
                handleChangeType={handleChangeType}
              />
            )
          }
        ];
  if (loading) {
    return null;
  }

  return (
    <div className="horizontal-wizard">
      <Wizard instance={(el) => setStepper(el)} ref={ref} steps={steps} />
    </div>
  );
};

export default WizardHorizontal;
